module.exports = __webpack_public_path__ + "static/media/about-picture1.684a6527.jpg";